import * as yup from 'yup'
import { consumesStock, requiresReason } from '../utils/marAdministration'

export const marSchema = yup.object().shape({
  medication: yup.string().notRequired(),
  note: yup.string().when('status', {
    is: requiresReason,
    otherwise: schema => schema.notRequired(),
    then: schema => schema.trim().required('Reason is required')
  }),
  quantity: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value))
    .when('status', {
      is: consumesStock,
      otherwise: schema => schema.notRequired(),
      then: schema =>
        schema
          .required('Quantity is required')
          .min(1, 'Quantity must be greater than 0')
          .test('max-ward-stock', 'Quantity cannot be greater than stock quantity', function (value) {
            const { ward_stock_quantity } = this.parent as { ward_stock_quantity?: number | string }
            if (value === undefined || value === null) {
              return true
            }

            const availableQty = Number(ward_stock_quantity)
            if (Number.isNaN(availableQty) || availableQty <= 0) {
              return true
            }

            return value <= availableQty
          })
    }),
  status: yup.string().required('Status is required'),
  ward_stock_id: yup.string().when('status', {
    is: consumesStock,
    otherwise: schema => schema.notRequired(),
    then: schema => schema.required('Drug is required')
  }),
  ward_stock_quantity: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value))
    .notRequired()
})
